var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.917 9.167v25.666L33.082 22z"
})));
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTIuOTE2NSA5LjE2Njc1VjM0LjgzMzRMMzMuMDgzMiAyMi4wMDAxTDEyLjkxNjUgOS4xNjY3NVoiLz4KPC9zdmc+Cg==";